import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { ApplicationInsightsService } from '@app/services/common/log.service';

@Injectable({ providedIn: 'root' })
export class GlobalErrorHandler implements ErrorHandler {

  constructor(private appInsights: ApplicationInsightsService) { }
  handleError(error: any ) {
    this.appInsights.logException(error, 1);
  }
  
}